
import { Vue, Component, Prop,Watch,Model } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import XEUtils from 'xe-utils'
@Component({
  name: "dicText",
  components: {
  },
})
export default class dicText extends BaseVue {
  // @Model('on-change') defaultValue!: any

  @Prop({ default: () => "" }) typeCode!: String; //字典类型编码
  @Prop({ default: () => "" }) defaultValue!: String;     //

  defaultText:any=""
  async mounted() {
     
  }
}
